import { useTranslation } from '@wix/wix-i18n-config';
import React from 'react';
import { useBiLogger } from '../../../contexts/BILoggerContext';
import { useExperiments } from '../../../contexts/ExperimentsContext';
import { useInitialState } from '../../../contexts/InitialStateContext';
import s from './GoToWorkspaceButton.scss';

type Props = {};

export const GoToWorkspaceButton: React.FC<Props> = () => {
  const { t } = useTranslation();
  const biLogger = useBiLogger();
  const experiments = useExperiments();
  const { isMobile, userData } = useInitialState();

  const url = 'https://manage.wix.com/studio/';

  const isGoToWorkspaceButton =
    userData.isLoggedIn &&
    !isMobile &&
    experiments.is('specs.funnel.StudioTemplatesGoToWorkspaceButton', 'true');

  const onGoToWorkspaceClick = () => {
    biLogger.reportGeneralAction({
      action: 'go_to_workspace',
      actionValue: 'go_to_workspace_button',
    });
  };

  if (!isGoToWorkspaceButton) {
    return null;
  }

  return (
    <a className={s.button} href={url} onClick={onGoToWorkspaceClick}>
      {t('app.topBar.goToWorkspace.button')} →
    </a>
  );
};
